import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query permissionControlsWithPagination($page: Int, $perPage: Int, $filters: FiltersPermissionControl) {
  permissionControlsWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
      }
      reason_id
      reason {
        id
        description
        abbreviated
      }
      date_start
      date_end
      observations
      valido
    }
  }
}
`

const GET_ALL = gql`
  query permissionControls ($filters: FiltersPermissionControl) {
    permissionControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
      }
      reason_id
      reason {
        id
        description
        abbreviated
      }
      date_start
      date_end
      observations
      valido
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createPermissionControl ($input: PermissionControlForm!) {
    createPermissionControl (input: $input) {
      id
    }
  }
`

const UPDATE = gql`
  mutation updatePermissionControl ($id: ID!, $input: PermissionControlForm!) {
    updatePermissionControl (id: $id, input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deletePermissionControl ($id: ID!) {
    deletePermissionControl(id: $id) { 
      id
    }
  }
`

export {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    GET_ALL
}
